var _ = require('lodash')

Ember.Handlebars.registerHelper('if-eq', function(path, value, options) {
    if (_.get(options.data.keywords, path) === value) {
        return options.fn(this)
    } else {
        return options.inverse(this)
    }
})
